export class TextRenderConfig {
}
TextRenderConfig.maxCanvasWidth = 4096;
TextRenderConfig.atlasWidth = 1024;
TextRenderConfig.atlasGridW = 16;
TextRenderConfig.noAtlas = false;
TextRenderConfig.forceSplitRender = false;
TextRenderConfig.forceWholeRender = false;
TextRenderConfig.scaleFontWithCtx = true;
TextRenderConfig.maxFontScale = 4;
TextRenderConfig.fontScale = 1;
TextRenderConfig.standardFontSize = 32;
TextRenderConfig.destroyAtlasDt = 10;
TextRenderConfig.checkCleanTextureDt = 2000;
TextRenderConfig.destroyUnusedTextureDt = 10;
TextRenderConfig.cleanMem = 100 * 1024 * 1024;
TextRenderConfig.showLog = false;
TextRenderConfig.debugUV = false;
TextRenderConfig.simClean = false;
TextRenderConfig.debugCharCanvas = false;
TextRenderConfig.useImageData = true;
